import { render, staticRenderFns } from "./userBox.vue?vue&type=template&id=07c06552&scoped=true&"
import script from "./userBox.vue?vue&type=script&lang=js&"
export * from "./userBox.vue?vue&type=script&lang=js&"
import style0 from "./userBox.vue?vue&type=style&index=0&id=07c06552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c06552",
  null
  
)

export default component.exports